import cn from 'clsx';
import { PropsWithChildren } from 'react';
import { createPortal } from 'react-dom';

export interface ModalProps extends PropsWithChildren {
  readonly isOpen: boolean;
}

const styles = {
  modalContainer: 'fixed inset-0 z-front overflow-auto',
  modalBackground:
    'absolute w-full h-full flex justify-center items-center inset-0 bg-black/25',
  modalDialog:
    'p-sm md:px-xl md:py-md relative flex overflow-hidden flex-col bg-white shadow w-full md:w-auto mx-sm md:mx-md md:mx-0 rounded-panel rounded-xl break-words text-center',
};

export function Modal({ isOpen, children }: ModalProps) {
  const renderModal = () => {
    return (
      <div className={cn(styles.modalContainer, isOpen ? 'block' : 'hidden')}>
        <div className={styles.modalBackground}>
          <div
            role="dialog"
            aria-modal="true"
            className={styles.modalDialog}
          >
            {children}
          </div>
        </div>
      </div>
    );
  };

  return createPortal(renderModal(), document.body);
}
